import { useQueryClient } from '@tanstack/vue-query';
import { setupChecklistKeys } from './setupChecklist.keys';

export function useRefreshSetupChecklist() {
  const queryClient = useQueryClient();

  const refreshSetupChecklist = async (): Promise<void> => {
    await queryClient.invalidateQueries({ queryKey: setupChecklistKeys.all });
  };

  return { refreshSetupChecklist };
}
